import { atom } from "recoil";

const loveLoading = atom({
  key: 'love-loading',
  default: true,
});

const loveData = atom({
  key: 'love-data',
  default: [],
});

const loveMessage = atom({
  key: 'love-message',
  default: {},
});

export {
  loveData,
  loveLoading,
  loveMessage,
}